module.exports = __webpack_public_path__ + "img/bg3.ac8f9b86.jpg";